'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../../../base-component.types';

import styles from './LegendItem.module.scss';

type ContainerProps = BaseComponentProps & {
  value: string;
  color: string;
  legendIcon: ReactNode;
};

export function LegendItem({
  style,
  className,
  value,
  color,
  legendIcon,
  testId,
}: ContainerProps) {
  return (
    <li
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <div
        className={styles['icon']}
        style={{
          color: color,
        }}
      >
        {legendIcon}
      </div>
      <span>{value}</span>
    </li>
  );
}
